import React, { useCallback, useEffect, useState } from 'react';
import { Tag } from './types';
import Tracking from './tracking';

type TagsProps = {
    baseUrl: string;
    position: string;
    updateRecommendations: (e: any) => void;
    resetRecommendations: () => void;
    trackClick: (adId: string, trackingUrlClick: string[]) => void;
};

const Tags: React.FC<TagsProps> = (props) => {
    const {
        baseUrl,
        position,
        updateRecommendations,
        resetRecommendations,
        trackClick,
    } = props;
    const [tags, setTags] = useState<Tag | undefined>(undefined);

    useEffect(() => {
        fetch(`${baseUrl}/mul/recommend/query?${position}`)
            .then((res) => res.json())
            .then((json: Tag) => {
                setTags(json);
            })
            .catch((e) => {});
    }, [baseUrl, position]);

    const setActive = useCallback((event) => {
        if (!event.target) return;
        const allDivs = event.target.parentNode.children;
        Array.from(allDivs).forEach((element: HTMLSpanElement) => {
            element.classList.remove('tag-selector-is-active');
        });
        event.target.classList.add('tag-selector-is-active');
    }, []);

    return (
        <>
            {tags && (
                <>
                    <span
                        className="tag-selector status"
                        onClick={(event) => {
                            setActive(event);
                            resetRecommendations();
                        }}
                    >
                        Se alle
                    </span>
                    {tags.items?.map((d, i) => (
                        <span
                            className="tag-selector status"
                            key={`ts_${i}`}
                            onClick={(event) => {
                                setActive(event);
                                updateRecommendations(event);
                                trackClick(d.itemId, Tracking.getClickUrl(d));
                            }}
                        >
                            {d.itemId}
                        </span>
                    ))}
                </>
            )}
        </>
    );
};

export default Tags;
